import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardText,
  Col,
  Row,
} from "reactstrap";
import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import { IsErrorOrLoading } from "../../utils/IsErrorOrLoading";
import ReactTooltip from "react-tooltip";

interface Props {
  address: string;
}

const VOTES_QUERY = gql`
  query votes($address: String!) {
    votes(address: $address) {
      username
    }
  }
`;

export const AccountVotes: React.FC<Props> = ({ address }) => {
  const {
    data: votesData,
    loading: loadingVotes,
    error: errorVotes,
    // refetch: votesRefetch,
  } = useQuery(VOTES_QUERY, {
    variables: {
      address: address,
    },
    // fetchPolicy: 'no-cache'
  });

  if (loadingVotes || errorVotes) {
    return (
      <div className="content">
        <IsErrorOrLoading error={!!errorVotes} title={"votes"} />
      </div>
    );
  }

  const votes = votesData.votes;

  return (
    <Card className="card-user">
      <CardBody style={{ minHeight: "unset" }}>
        <CardText />
        <div className="author">
          <h5 className="title">
            {votes.length
              ? `This Account is voting for ${votes.length} delegates:`
              : "This account is not voting"}
          </h5>
        </div>
        <div className="card-description">
          <Row>
            <Col md={12}>
              {votesData.votes.map((v: { username: string }) => {
                return <Badge className={"badge-dark"}>{v.username}</Badge>;
              })}
            </Col>
          </Row>
        </div>
      </CardBody>
      <ReactTooltip />
    </Card>
  );
};
